import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="hashcash"
// Defers loading the hashcash script until the user starts interacting with the form.
// Keeps the submit button disabled until both the hashcash is solved and 3 seconds have passed.
export default class extends Controller {
  static values = { src: String };

  connect() {
    this.loaded = false;
    this.hashcashSolved = false;
    this.timerElapsed = false;
    this.submitButton = this.element.querySelector("[type=submit]");
    this.submitButton.disabled = true;

    this.handler = () => this.loadHashcash();
    this.element.addEventListener("input", this.handler, { once: true });
    this.element.addEventListener("hashcash:minted", () =>
      this.onHashcashMinted(),
    );
  }

  disconnect() {
    this.element.removeEventListener("input", this.handler);
    if (this.timer) clearTimeout(this.timer);
  }

  loadHashcash() {
    if (this.loaded) return;
    this.loaded = true;

    this.timer = setTimeout(() => {
      this.timerElapsed = true;
      this.maybeEnableSubmit();
    }, 3000);

    console.info(
      "To prevent spam, we use a hashcash algorithm instead of a captcha. It will solve while you fill out the form. You'll see the output of the hashcash solution below. Learn more: https://en.wikipedia.org/wiki/Hashcash",
    );

    const script = document.createElement("script");
    script.src = this.srcValue;
    document.head.appendChild(script);
  }

  onHashcashMinted() {
    this.hashcashSolved = true;
    this.submitButton.disabled = !this.timerElapsed;
  }

  maybeEnableSubmit() {
    if (this.hashcashSolved && this.timerElapsed) {
      this.submitButton.disabled = false;
    }
  }
}
